module.exports = __webpack_public_path__ + "static/media/big_smartsampa_logo_lightAlt.1922795b.png";